import { FunctionComponent } from 'react'
import { css } from '@emotion/css'
import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'
import { Venue } from '@/libs/helpers/adapters'
import {
  formatASAPOTLimitReachedMessage,
  getOrderMethodSettings,
  getRelativeTimeToNextAvailableInterval,
  OrderMethod,
} from '@/libs/helpers/utils'
import { useModal } from '@/providers/modal'
import { useUserLanguage } from '@/providers/userLanguage'
import { Button, Grid, SvgIcon, Text } from '@/tbui'
import InfoBanner from '../InfoBanner'

const viewMenuStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

export interface PickupOnlyReachLimitModalProps {
  venue: Venue
  onClose?: (() => void) | (() => Promise<void>)
  confirmText?: string
}

const PickupOnlyReachLimitModal: FunctionComponent<PickupOnlyReachLimitModalProps> = ({
  venue,
  onClose,
  confirmText,
}) => {
  const { t } = useTranslation()
  const { userLanguage } = useUserLanguage()
  const { closeModal } = useModal()
  const { isSchedulingAvailable, weeklySchedule } = getOrderMethodSettings(
    venue.venueOrderingMethods,
    OrderMethod.pickup
  )

  return (
    <Grid p=".25rem" gap="1.25rem" data-test="order-method-modal">
      <Text type="H1" css={{ textAlign: 'center' }}>
        {venue.name}
      </Text>
      <InfoBanner
        type="warning"
        message={formatASAPOTLimitReachedMessage(
          t,
          isSchedulingAvailable,
          false,
          getRelativeTimeToNextAvailableInterval(DateTime.local(), 15, weeklySchedule, userLanguage)
        )}
      />
      <Button
        data-test="order-method-submit"
        onClick={async () => {
          await onClose?.()
          closeModal()
        }}
      >
        <Grid className={viewMenuStyles}>
          <SvgIcon
            name="course"
            fontSize="24px"
            color="TEXT_PRIMARY"
            style={{ marginRight: '8px' }}
          />
          {confirmText ?? t('order_method_selector.view_menu')}
        </Grid>
      </Button>
    </Grid>
  )
}

export default PickupOnlyReachLimitModal
